import React from 'react';
import classnames from 'classnames';
import Isvg from 'react-inlinesvg';

import tick from 'app/images/icons/tick.svg';

interface ICheckboxProps {
  checked: boolean;
  radio: boolean;
  onClick: Function;
  onMouseDown: Function;
  onMouseMove: Function;
  className: string;
}

export default class Checkbox extends React.Component<ICheckboxProps> {
  static defaultProps: ICheckboxProps = {
    checked: false,
    radio: false,
    onClick: undefined,
    onMouseDown: undefined,
    onMouseMove: undefined,
    className: '',
  };

  state = {
    mouseDown: false,
  }

  onMouseDown = (e) => {
    if (this.props.onMouseDown !== undefined) {
      this.props.onMouseDown(e);
    }
    this.setState((previousState) => ({
      mouseDown: true,
    }));
  }

  onMouseUp = () => {
    this.setState((previousState) => ({
      mouseDown: false,
    }));
  }

  render(): React.ReactNode {
    return (
      <div
        className={classnames(
          'checkbox-square',
          { checked: this.props.checked },
          { radio: this.props.radio },
          { 'mouse-down': this.state.mouseDown },
          this.props.className,
        )}
        onClick={this.props.onClick}
        onMouseLeave={this.onMouseUp}
        onMouseDown={this.onMouseDown}
        onMouseUp={this.onMouseUp}
        onMouseMove={this.props.onMouseMove}
      >
        <Isvg src={tick} className={classnames('tick', { 'd-none': (!this.props.checked || this.props.radio) })} />
        <div className={classnames('radio-circle', { 'd-none': !(this.props.checked && this.props.radio) })} />
      </div>
    );
  }
}
